'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    button: (0, _functional.getElement)('.ck-Banner_Button', { context: el })
  };

  this.els.button.addEventListener('click', function (e) {
    _jsCookie2.default.set('carat-london-cookie-information', 'true', {
      expires: 3650
    });

    _this.els.el.classList.remove('ck-Banner-active');
  });
};

exports.default = _class;